// Define a single auth context instance cache
let authContext: any = null;

/**
 * Get the current auth context
 * This avoids circular dependencies when importing from hooks
 */
export const getAuth = () => {
  if (!authContext) {
    throw new Error('Auth context not initialized');
  }
  return authContext;
};

/**
 * Set the auth context
 * This is called in AuthProvider after initialization
 */
export const setAuth = (context: any) => {
  authContext = context;
};
